import { render, staticRenderFns } from "./log-modal.vue?vue&type=template&id=0b4773d4&scoped=true&"
import script from "./log-modal.vue?vue&type=script&lang=js&"
export * from "./log-modal.vue?vue&type=script&lang=js&"
import style0 from "./log-modal.vue?vue&type=style&index=0&id=0b4773d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4773d4",
  null
  
)

export default component.exports